<template>
	<div v-loading.fullscreen.lock="loading">
		<upload :quantity="currentQuantity" ref="upload" @updateLoading="updateLoading" @updateAllSize="updateAllSize" v-bind="$attrs" v-on="$listeners"></upload>
		<div class="operate-buttons">
			<p class="info-tip">*批量操作可能需要较长时间，请耐心等待</p>
			<el-button type="primary" @click="submit" >提 交</el-button>
			<el-button @click="close" :disabled="loading" type="primary" plain>返 回</el-button>
		</div>
	</div>
</template>
<script>
import upload from './upload'
export default {
  name: 'process-dialog',
  props: {
    quantity: {
      type: [String]
    }
  },
  components: {
    upload
  },
  data () {
    return {
      loading: false,
      notificeRefresh: false
    }
  },
  computed: {
    currentQuantity () {
      return this.quantity
    }
  },
  methods: {
    submit () {
      this.$refs.upload.uploadSubmit()
    },
    close () {
      this.$router.push('/gene-lab-order')
    },
    updateLoading (val) {
      this.loading = val
      // this.$emit('getCurrentStatusTotal')
      // this.$refs.selected.reload()
    },
    updateAllSize (val) {
      this.$emit('updateAllSize', val)
    }
  }
}
</script>
<style lang="less">
</style>
